import { api } from "../../utils/api";

export const onSubmitBlock = async (id, data) => {
  console.log(id)
  console.log(data)
  try {
    data.enterprise_id = id;
    const response = await api.post("block", data);
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}